import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import PageHead from "@/components/feature/PageHead";

const COMPANY_NAME = "NetBasis International";

const title = "Market Entry Strategies";
const heroImage = "https://net-basis.net/Bilder/dach-market-entry-strategy-target-market-positioning.webp";
const heroAlt = "Hand marks a red target segment in overlapping circles for the market entry strategy.";
const heroClaimLine1 = "Heading for";
const heroClaimLine2 = "your market share!";
const benefitsTitle = "How you benefit from our __Market Entry Strategy__ expertise:";
const introText = "Strategic market entry strategies for your sustainable success in the DACH market. As your experienced local resource, we support foreign ICT manufacturers in identifying, developing, and designing optimal entry options into the German-speaking economic region.";
const p1Text = "NetBasis International is its partners' local resource for identifying, developing, and designing entry options into new markets. Through targeted market research and profound market insights, we accompany the entire planning process of our manufacturer partners, help make crucial strategic key decisions, and achieve the best possible market presence on the ground.";
const p1Parts = p1Text.split(COMPANY_NAME);
const bottomClaim = "NetBasis International - drive to excellence with excellent drivers !";

const benefits = [
  "Execution of detailed market assessments and well-founded evaluations of the target markets",
  "General decision-making support and guidance on which regional sub-markets should be invested in",
  "Comprehensive assistance in planning and execution based on local market observation",
  "Thorough analysis of potential competitors as well as identification of relevant target customers",
  "Direct access to our established sales networks for rapid generation of market share",
  "Ensuring all necessary commercial skills and expertise for a successful market entry project",
];

export default function MarketEntryStrategiesEnPage() {
  return (
    <div className="min-h-screen flex flex-col">
      <PageHead
        title="Market Entry Strategies | NetBasis International"
        description="Tailored concepts and strategic roadmaps for the safe and efficient launch of your business in the DACH region."
        ogUrl="https://net-basis.net/en/services/business-development/market-entry-strategies"
      />
      <Header />

      <main className="flex-1 pt-20 md:pt-24">
        {/* Hero image */}
        <section className="w-full bg-white py-4 md:py-6 lg:py-8">
          <div className="w-full max-w-[1100px] mx-auto">
            <div className="relative w-full h-[320px] md:h-[420px] lg:h-[500px] overflow-hidden">
              <img loading="lazy"
                src={heroImage}
                alt={heroAlt}
                title={title}
                className="absolute inset-0 w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50"></div>

              <div className="absolute inset-0 z-20 flex items-start justify-center pt-[14%] md:pt-[10%] lg:pt-[9%] pointer-events-none">
                <p
                  className="mes-hero-lh-15 markteintritt-hero-text-slide text-3xl md:text-4xl lg:text-5xl font-normal text-white drop-shadow-[0_1px_4px_rgba(0,0,0,0.6)] text-center"
                  style={{ fontFamily: '"Open Sans", sans-serif' }}
                >
                  <span className="block md:hidden">{heroClaimLine1}</span>
                  <span className="block md:hidden">{heroClaimLine2}</span>
                  <span className="hidden md:block">{heroClaimLine1} {heroClaimLine2}</span>
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Content */}
        <section className="py-6 md:py-8 px-4 md:px-6 lg:px-8 bg-white">
          <div className="max-w-5xl mx-auto">
            <h2 className="font-heading text-lg md:text-xl font-bold text-primary-600 mb-5 md:mb-7">
              {title}
            </h2>

            <h1 className="font-semibold text-foreground-950 leading-relaxed text-sm md:text-base mb-4">
              {introText}
            </h1>

            <div className="space-y-4 text-foreground-950 leading-relaxed text-sm md:text-base">
              <p>
                {p1Parts.map((part, i) => (
                  <span key={i}>
                    {part}
                    {i < p1Parts.length - 1 && (
                      <strong className="text-primary-600">{COMPANY_NAME}</strong>
                    )}
                  </span>
                ))}
              </p>
            </div>

            {/* Green heading with italic word */}
            <h2 className="font-heading text-lg md:text-xl font-bold text-primary-600 mt-8 md:mt-10 mb-5 md:mb-7">
              {benefitsTitle.split("__").map((part, i) =>
                i % 2 === 1 ? <em key={i}>{part}</em> : part
              )}
            </h2>

            {/* Benefits with green checkmarks */}
            <div className="space-y-1.5 md:space-y-2 text-foreground-950 leading-relaxed text-sm md:text-base">
              {benefits.map((benefit, idx) => (
                <div key={idx} className="flex items-start gap-2 md:gap-3">
                  <div className="w-5 h-5 flex-shrink-0 flex items-center justify-center mt-0.5">
                    <i className="ri-check-line text-primary-600 text-base md:text-lg"></i>
                  </div>
                  <p>{benefit}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Bottom claim */}
        <section className="py-6 md:py-10 px-4 md:px-6 lg:px-8 bg-white">
          <div className="max-w-5xl mx-auto text-center">
            <p className="font-heading text-lg md:text-xl font-bold text-primary-600">
              {bottomClaim}
            </p>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}